import { useGetQBankStructureByIdLazyQuery } from '@exam-management/graphql';
import { useEffect, useRef, useState } from 'react';

export default function useQBankLabels(ids: string[]) {
  const [getById, { loading }] = useGetQBankStructureByIdLazyQuery({ fetchPolicy: 'cache-first' });
  const [labels, setLabels] = useState<Record<string, string>>({});
  const requestedRef = useRef(new Set<string>());

  useEffect(() => {
    let active = true;

    const fetchQbs = async () => {
      const fetchedLabels: Record<string, string> = {};

      for (const id of ids) {
        if (requestedRef.current.has(id)) continue;
        try {
          const res = await getById({ variables: { id } });
          const qbs = res.data?.qbsGetQBankStructureById;

          if (!qbs) continue;

          fetchedLabels[id] = `${qbs.code}: ${qbs.name}`;
        } catch {
          // leave id out of requestedRef so it can be retried
        }
      }

      if (active) {
        setLabels((prev) => ({ ...prev, ...fetchedLabels }));
        Object.keys(fetchedLabels).forEach((id) => requestedRef.current.add(id));
      }
    };

    fetchQbs();

    return () => {
      active = false;
    };
  }, [ids, getById]);

  return { data: labels, loading };
}
